import { TableHeader } from "../../commons";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../commons/ScrollToTop";
import HolidayCalenderTableData from "./HolidayCalenderTableData";
import { HOLIDAY_CALENDER_HEADERS } from "../../../constant/tableHeadersConstants/masterDataContants/masterDataHolidayConst";
import { HolidayCalenderListType } from "../../../redux/masterData/masterTypes";

type AppProps = {
  fetching?: boolean;
  offset?: number | undefined;
  data: HolidayCalenderListType[] | [];
  handleEditMasterHolidayCalender?: (
    data: HolidayCalenderListType
  ) => void | undefined;
  handleDeleteHolidayCalender?: (
    data: HolidayCalenderListType
  ) => void | undefined;
  handleShowConfirmationModal?: (data: number) => void | undefined;
  isUpdateHolidayCalenderPresent?:boolean;
  isDeleteHolidayCalenderPresent?:boolean;
};

const HolidayCalenderTable = ({
  fetching,
  offset,
  data,
  handleEditMasterHolidayCalender,
  handleDeleteHolidayCalender,
  handleShowConfirmationModal,
  isUpdateHolidayCalenderPresent,
  isDeleteHolidayCalenderPresent
}: AppProps) => {
  return (
    <div className="jobsType">
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header-without-zindex">
          <TableHeader tableHeader={HOLIDAY_CALENDER_HEADERS} />
        </thead>
        <tbody>
          <HolidayCalenderTableData
            data={data}
            tableHeader={HOLIDAY_CALENDER_HEADERS}
            handleEditMasterHolidayCalender={handleEditMasterHolidayCalender}
            handleDeleteHolidayCalender={handleDeleteHolidayCalender}
            handleShowConfirmationModal={handleShowConfirmationModal}
            isUpdateHolidayCalenderPresent={isUpdateHolidayCalenderPresent}
            isDeleteHolidayCalenderPresent={isDeleteHolidayCalenderPresent}
          />
          {fetching && offset && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default HolidayCalenderTable;
